import * as React from 'react';
import { useContext } from 'react';
import { AuthContext } from '../_auth/AuthContext';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';

interface Props {

};

const AdminHome: React.FC<Props> = (prop: Props) => {
    const { user } = useContext(AuthContext);

    const history = useHistory();

    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            spinner: {
                marginLeft: 5,
                color: 'primary',
            },
            formControl: {
                margin: theme.spacing(1),
                minWidth: 120,
            },
            selectEmpty: {
                marginTop: theme.spacing(2)
            },
            header: {
                marginBottom: theme.spacing(1),
                marginTop: theme.spacing(1)
            }
        }),
    );
    const classes = useStyles();


    const NavTo = (e: any, path: string) => {
        history.push('/admin/' + path);
    }

    return (
        <div>Hello, this should be the marketing area for tabs</div>
    )

}

export default AdminHome;